import React from "react";
const AnimatedInput = (props) => {
  return (
    <div className="input-field">
      {props.useformInput ? (
        <input
          type="text"
          {...props.register(props.registerName,props.inputOptions)}
          id={props.id} 
          placeholder={props.placeholder}
        />
      ) : (
        <input type="text" {...props.attrInput} id={props.id} placeholder={props.placeholder} />
      )}

      {/* <label htmlFor={props.id}>{props.label}</label> */}
    </div>
  );
};

export default AnimatedInput;
